export default class ScreenSizeManager {
    // singleton pattern
    private static singleton: ScreenSizeManager;
  
    private readonly screenTypeConfig: { [key: string]: [number, number | null] } = {
      mobile: [0, 768],
      tablet: [768, 992],
      desktop: [992, null],
    };
    private viewPortWidth: number | undefined;
    private screenType: string | undefined;
  
    constructor() {
      if (ScreenSizeManager.singleton) {
        return ScreenSizeManager.singleton;
      }
  
      ScreenSizeManager.singleton = this;
      return ScreenSizeManager.singleton;
    }
  
    // getScreenType(): string | undefined {
    //   return this.screenType;
    // }
  
    private getViewportWidth(): number {
      return Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0);
    }
  
    private checkWidthForScreenType(type: string): boolean {
      const [lower, upper] = this.screenTypeConfig[type];
      if (lower && this.viewPortWidth && this.viewPortWidth < lower) {
        return false;
      }
      if (upper && this.viewPortWidth && this.viewPortWidth >= upper) {
        return false;
      }
      return true;
    }
  
    private isMobile(): boolean {
      return this.checkWidthForScreenType("mobile");
    }
  
    private isTablet(): boolean {
      return this.checkWidthForScreenType("tablet");
    }
  
    private isDesktop(): boolean {
      return this.checkWidthForScreenType("desktop");
    }
  
    private getScreenType(): string | undefined {
      if (this.isMobile()) return "mobile";
      if (this.isDesktop()) return "desktop";
      if (this.isTablet()) return "tablet";
    }
  
    private updateData(): void {
      const currentScreenType = this.screenType;
      this.viewPortWidth = this.getViewportWidth();
      const newScreenType = this.getScreenType();
      this.screenType = newScreenType;
      if (currentScreenType !== newScreenType) {
        window.dispatchEvent(new CustomEvent("screenTypeChange", { detail: { newType: this.screenType } }));
      }
    }
  
    private setListeners(): void {
      const resizeListener = () => {
        window.removeEventListener("resize", resizeListener);
  
        this.updateData();
  
        setTimeout(() => {
          window.addEventListener("resize", resizeListener, { passive: true });
        }, 50);
      };
      window.addEventListener("resize", resizeListener);
    }
  
    init(): void {
      this.updateData();
      this.setListeners();
    }
  }
  